import { render, staticRenderFns } from "./testUserInfo.vue?vue&type=template&id=6398bfd5&scoped=true"
import script from "./testUserInfo.vue?vue&type=script&lang=js"
export * from "./testUserInfo.vue?vue&type=script&lang=js"
import style0 from "./testUserInfo.vue?vue&type=style&index=0&id=6398bfd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398bfd5",
  null
  
)

export default component.exports